<template>
<div class="modal" tabindex="-1" id="edit-lessoncat-modal">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header bg-custom">
                <div class="row text-wrap">
                     <div class="text-wrap"><h5 >Edit/Create a &nbsp;Lesson Category for Course: </h5><span>{{courseName}}</span>
                   <br/><small style="font-size:10px;">These are the 'groups' or 'headings' under which all your lessons in this course will be organized</small></div>
                </div> <div class="row">
                <button type="button" @click="cancel" class="close" title="Close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
                </div>
            </div>
            <div class="modal-body">
                <div class="row" >
                    <div class="col-10">
                    <h5 class="modal-title text-bold">Course:</h5>
                    <h2 class="bg-secondary text-center" v-if="lessoncatData" v-html="'<strong>Lesson Category:</strong> ' + (lessoncatData.name?lessoncatData.name:'(New)')"></h2>
                    <div style="visibility:block;" class="col-12">
                    <input style="display:block;width:80%;" type="text" v-model="lessoncatData.name" placeholder="Lesson Category Name"/>
                    <input style="display:block;width:80%;" type="text" v-model="lessoncatData.byline" placeholder="Lesson Category Byline"/>
                    <input style="display:block;width:80%;"  type="number" v-model="lessoncatData.order_num" placeholder="Order"/>
                    </div>
                    <button class="btn btn-lg btn-warning float-right mx-2 my-2" @click="cancel">Close</button>
                    <button class="btn btn-lg btn-primary float-right  mx-2 my-2" @click="saveLessonCategAction">Save All</button>
                    </div>
                </div>
             </div></div></div></div>

</template>

<script>
import axios from 'axios';
import Swal from 'sweetalert2';
import EventBus from '../../../event-bus';


import { v4 as uuidv4 } from 'uuid';

export default {
    components: {
     },
    name: "ManageLessonCategory",
    data() {
        return {
            csrf_token: document.head.querySelector('meta[name="csrf-token"]').getAttribute('content'),
            userinfo:'',
            // coursedata:{},
            lessoncat:{},
            lessoncatData:{},
            courseName:'',
            course_id:'',
        }
    },

    props: {
        user:'',
        courses:'',
        apikey:'',
    },
    mounted() {
          this.userinfo = JSON.parse(this.user);
            EventBus.$on('newLessonCatModal', (data) => {
            console.error(" lessonCategModal::cr new course.");
            this.modalReset();
            this.courseName = data.courseName;
            this.course_id = data.courseID;
            $('div#edit-lessoncat-modal').modal('show');
        });

        EventBus.$on('editLessonCatModal', (data) => {
            this.courseName = data.courseName;
            this.course_id = data.courseID;
            this.lessoncatData = Object.assign({}, data.lessonCatData);
            $('div#edit-lessoncat-modal').modal('show');
        });

    },

    methods: {
        saveLessonCategAction() {
            axios.post('/edu/lessoncat/saveupdate', {
                course_id:this.course_id,
                id:this.lessoncatData.id,
                name:this.lessoncatData.name,
                byline:this.lessoncatData.byline,
                order_num: this.lessoncatData.order_num,
            })
            .then(res => {
                this.loading = false;
                this.success = true;
                this.message = res.data.message;
                this.updateToast(this.message, 4000);
                console.error(res.data.message);
                this.lessoncatData = JSON.parse(res.data.lessoncat);
                EventBus.$emit('refreshParentPage');
            })
            .catch(err => {
                // this.loading = false;
                // this.failure = true;
                // this.success = false;
                console.error(err);
                this.updateToast(err.message, 4000, 'error');
            })
            .finally(()=> {
                // location.reload();
            });
        },

         getGUID() {
            var guid = uuidv4();
            // console.log("GUID: " + guid);
            return guid;
        },
        modalReset() {
            //set all fields to blank
            this.lessoncatData.id = '';
            this.lessoncatData.name = '';
            this.lessoncatData.byline = '';
            this.lessoncatData.course_id = '';
            this.lessoncatData.order_num = '';
        },
        // cancelLessonCat() {
        //     console.log("Cancel close FSLifeArea");
        //     $('div#edit-course-modal').modal('hide');
        //     // EventBus.$emit('refreshParentPage');
        //     // location.reload();
        // },
        // getTemplate(life_area) {
        //      console.log("Looking for template with id " + life_area);
        //     return this.templates.find((template) =>{
        //             // console.log(life_area + ' : '+ template.life_area);
        //         if(template.life_area == life_area) {
        //             // console.log("Found template...");
        //             return template;
        //         }
        //     });
        // },
        // getInitMenuPlugins() {
        //     return {
        //         height: 200,
        //         menubar: false,
        //         plugins: [
        //             'code table lists'
        //         ],
        //         toolbar:
        //             'undo redo | formatselect | bold italic backcolor | \
        //             alignleft aligncenter alignright alignjustify | \
        //             bullist numlist outdent indent | removeformat | help'
        //     }
        // },
        // saveAction() {
        //     // console.log(this.$refs);
        //     //console.log(this.$refs.vizInp.value);
        //     // console.log(this.$refs.planInp.value);
        //     // console.log(this.$refs.mezInp.value);
        //     this.saveDetails();
        // },

        // saveDetails() {
        //     axios.post('/fself/setup/saveupdate', {
        //         user_id:this.userinfo.id,
        //         id:this.id,
        //         life_area:this.fsModel.life_area,
        //         vision:this.fsModel.vision,
        //         plan:this.fsModel.plan,
        //         measure:this.fsModel.measure,
        //     })
        //     .then(res => {
        //         this.loading = false;
        //         this.success = true;
        //         this.message = res.data.message;
        //         this.updateToast(this.message, 4000);
        //         console.error(res.data.message);
        //     })
        //     .catch(err => {
        //         // this.loading = false;
        //         // this.failure = true;
        //         // this.success = false;

        //     })
        //     .finally(()=> {
        //         // location.reload();
        //     });

        // },
        updateToast(message, timer = 2000, icon='success') {
            const Toast = Swal.mixin({
                position: 'center',
                width: 500,
                showConfirmButton: true,
            });
            Toast.fire({
                icon: icon,
                title: message
            });
        },
        cancel() {
            // EventBus.$emit('refreshParentPage');
        $('div#edit-lessoncat-modal').modal('hide');
        }

    },
    computed: {
    },
}
</script>
<style>
.bg-custom{
    background: #449acb;
color: #fff;
}
</style>
